import { createSlice } from '@reduxjs/toolkit';
import { fetchPermissionsThunk } from '../thunks/userAuthThunks.js';

const initialState = {
    modal: {
        calendarInfo: { isOpen: false },
        vacation: { isOpen: false },
        vacationEdit: { isOpen: false },
        vacationEditModal: { isOpen: false },
        vacationStatistic: { isOpen: false },
        workingDay: { isOpen: false },
        workingDayEdit: { isOpen: false },
        sickLeave: { isOpen: false },
        sickLeaveEdit: { isOpen: false },
        exportCalendar: { isOpen: false },
        workingTime: { isOpen: false },
        workingTimeEdit: { isOpen: false },
        workingTimeEditViewMode: { isOpen: false },
        eventView: { isOpen: false },
        holiday: { isOpen: false },
        holidayEdit: { isOpen: false },
        team: { isOpen: false },
        teamEdit: { isOpen: false },
        addToTeam: { isOpen: false },
        remoteCalendar: { isOpen: false },
        remoteCalendarEdit: { isOpen: false },
        user: { isOpen: false },
        userEdit: { isOpen: false },
        userView: { isOpen: false },
        settingEdit: { isOpen: false },
        emailTemplateEdit: { isOpen: false },
        settingCreate: { isOpen: false },
    },
    dashboard: {
        showTeammates: false,
    },
    settings: {
        perPage: 10,
    },
    permissions: {},
};

const generalSlice = createSlice({
    name: 'general',
    initialState,
    reducers: {
        toggleModal: (state, action) => {
            const { modal, isOpen } = action.payload;
            state.modal[modal] = { isOpen };
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchPermissionsThunk.pending, (state) => {
                state.permissions = {};
            })
            .addCase(fetchPermissionsThunk.rejected, (state) => {
                state.permissions = {};
            })
            .addCase(fetchPermissionsThunk.fulfilled, (state, action) => {
                state.permissions = action.payload;
            })
            .addDefaultCase((state) => state);
    },
});

export const { toggleModal } = generalSlice.actions;
export default generalSlice.reducer;
